var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconFavourite = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M11.3025 3.47394L9.17925 8.84169L3.687 9.30444C3.033 9.35919 2.76 10.1692 3.24825 10.6087L7.45875 14.4022L6.17025 20.0834C6.02175 20.7382 6.7425 21.2429 7.30725 20.8807L12.0007 17.8664L16.6943 20.8807C17.259 21.2437 17.9797 20.7382 17.8312 20.0834L16.5427 14.4022L20.7533 10.6087C21.2415 10.1692 20.9685 9.35919 20.3145 9.30444L14.8223 8.84169L12.699 3.47394C12.4492 2.84169 11.5545 2.84169 11.304 3.47394H11.3025ZM10.4033 9.82644L12 5.78919L13.5968 9.82644C13.7017 10.0912 13.9478 10.2742 14.2313 10.2982L18.4613 10.6544L15.2108 13.5824C15.009 13.7639 14.9213 14.0407 14.9813 14.3054L15.9615 18.6284L12.405 16.3447C12.1583 16.1857 11.841 16.1857 11.5942 16.3447L8.03775 18.6284L9.018 14.3054C9.078 14.0407 8.99025 13.7639 8.7885 13.5824L5.538 10.6544L9.768 10.2982C10.0522 10.2742 10.2975 10.0919 10.4025 9.82644H10.4033Z", fill: "black" }))),
        alt: 'Favourite',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconFavourite;
//# sourceMappingURL=index.js.map